module.exports = __webpack_public_path__ + "img/logo_11_hover.d86f7d65.png";